import { render, staticRenderFns } from "./SportelloTipiBollettaView.vue?vue&type=template&id=7c3bc945&"
import script from "./SportelloTipiBollettaView.vue?vue&type=script&lang=ts&"
export * from "./SportelloTipiBollettaView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports